import React, { useState, useEffect } from 'react';

import { Card, CardContent, Stack, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { labelCnigSurface, labelCnigCondition } from 'handimap-react-lib/utils/cnigMapping';
import { useLabelValue } from 'handimap-react-lib/utils/useLabelValue';
import { AccBadge } from 'handimap-react-lib/components/Badge/AccBadge';
import { LengthBadgeFeature } from 'handimap-react-lib/components/Badge/LengthBadge';

export const CardInfoGraph = ({selectedGraph}) => {

  const {displayType} = useLabelValue();
  const {t} = useTranslation();

  const [graphProperties, setGraphProperties] = useState({});

  const style = {
    card: {
      display: 'flex',
      width: '90%',
      paddingX: '.2em',
    },
    cardContent: {
      display: 'flex',
      width: '100%'
    },
    labelCard: {
      fontSize: '1.1em'
    },
    labelPart: {
      fontSize: '0.8em'
    }
  };

  useEffect(() => {
    setGraphProperties(selectedGraph.properties);
    return () => {
      setGraphProperties({});
    };
  }, [selectedGraph]);

  const RowInfo = ({label, children}) => {
    return (
      <Stack sx={{display: 'flex', width: '100%', alignItems: 'center'}} spacing={2} direction='row'>
        <Typography sx={style.labelPart}>
          {label} :
        </Typography>
        {children}
      </Stack>
    );
  };

  const calcWidth = value => {
    const valueNumber = Number(value).toFixed(1);
    if (valueNumber > 2) {
      return t('stepPath.more_2');
    } else {
      return `${valueNumber} m`;
    }
  };
    
  const renderInfo = () => {
    return (
      <Stack sx={{display: 'flex', width: '100%'}} spacing={2} direction='column'>
        <Box sx={{display: 'flex', width: '100%'}}>
          <Typography sx={style.labelCard}>
            {graphProperties.name}
          </Typography>
        </Box>
        <RowInfo label='Type'>
          <Typography sx={style.labelPart}>
            {displayType(graphProperties.type)}
          </Typography>
        </RowInfo>
        <RowInfo label={t('stepPath.label-access')}>
          <AccBadge acc={graphProperties.acc} />
        </RowInfo>
        <RowInfo label= {t('stepPath.label-coating')}>
          <Typography sx={style.labelPart}>
            {graphProperties.surface ? t(`${labelCnigSurface(graphProperties.surface)}`) : t('stepPath.label-unknown')}
          </Typography>
        </RowInfo>
        <RowInfo label= {t('stepPath.label-condition')}>
          <Typography sx={style.labelPart}>
            {graphProperties.condition ? t(`${labelCnigCondition(graphProperties.condition)}`) : t('stepPath.label-unknown')}
          </Typography>
        </RowInfo>
        <RowInfo label= {t('stepPath.label-length')}>
          <LengthBadgeFeature feature={selectedGraph} />
        </RowInfo>
        <RowInfo label={t('stepPath.label-width')}>
          <Typography sx={style.labelPart}>
            {graphProperties.width ? calcWidth(graphProperties.width) : t('stepPath.label-unknown')}
          </Typography>
        </RowInfo>
        <RowInfo label={t('stepPath.label-tilt')}>
          <Typography sx={style.labelPart}>
            {graphProperties.slope ? `${Number(graphProperties.slope).toFixed(1)} °` : t('stepPath.label-unknown')}
          </Typography>
        </RowInfo>
      </Stack>
    );
  };

  return (
    <Card sx={style.card}>
      <CardContent sx={style.cardContent}>
        {renderInfo()}
      </CardContent>
    </Card>
  );
};